import ReactDOM from "react-dom/client";
import dynamic from 'next/dynamic';
import {OpenPopup} from "./index";

declare global {
    interface Window {
        openSignUpPopup: (section: any) => Promise<void>;
        openPopup: (section: any) => Promise<void>;
    }
}

if (typeof window !== "undefined") {
    window.openSignUpPopup = async (input: any) => {
        console.log('openSignUpPopup---------------------');
        const SignUpPopup = dynamic(() => import('../signup_form/signupform'), {
            ssr: false,
        });

        const popupContainer = document.createElement('div');
        document.body.appendChild(popupContainer);

        const root = ReactDOM.createRoot(popupContainer);
        const closePopup = () => {
            root.unmount();
            document.body.removeChild(popupContainer);
        };

        root.render(
            <SignUpPopup type={input?.type} onCloseHandler={closePopup} />
        );
    };
    window.openPopup = async (input: any) => {
        console.log('openPopup---------------------');
       
        const popupContainer = document.createElement('div');
        document.body.appendChild(popupContainer);

        const root = ReactDOM.createRoot(popupContainer);

        root.render(
            <OpenPopup sectionData={input} />
        );
    }

}